// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"e3464af9","147":"5297086c","295":"40210304","362":"2e54b1cc","574":"58aaeade","807":"7ca1f953","818":"0bffd189","899":"9954d943","900":"958324ff","996":"88595dee"}[chunkId] + ".chunk.js";
};